import { gql } from 'apollo-boost';

export const pricePackagesQuery = gql`
    query PricePackagesQuery($input: GdGetPricePackagesInput!) {
        reqId: getReqId
        getPricePackages(input: $input) {
            totalCount
            rowset {
                id
                title
                price
                currency
                orderVolumeMin
                orderVolumeMax
                targetingsFixed {
                    viewTypes
                    geo
                    geoType
                }
                targetingsCustom {
                    behaviors
                    geo
                    geoType
                }
                statusApprove
                dateStart
                dateEnd
                clientIds
                lastUpdateTime
            }
        }
    }
`;

export const pricePackagesSuggest = gql`
    query PricePackagesSuggestQuery($input: GdGetPricePackagesInput!) {
        reqId: getReqId
        getPricePackages(input: $input) {
            rowset {
                id
                title
            }
        }
    }
`;

export const pricePackagesQueryForEdit = gql`
    query PricePackagesQueryForEdit($input: GdGetPricePackagesInput!) {
        reqId: getReqId
        getPricePackages(input: $input) {
            totalCount
            rowset {
                id
                title
                price
                currency
                trackerUrl
                orderVolumeMin
                orderVolumeMax
                targetingsFixed {
                    viewTypes
                    geo
                    geoType
                }
                targetingsCustom {
                    behaviors
                    geo
                    geoType
                }
                statusApprove
                lastUpdateTime
                dateStart
                dateEnd
                clientIds
            }
        }
    }
`;

export const pricePackagesAvailableForClient = gql`
    query PricePackagesAvailableForClient {
        getPricePackagesAvailableForClient {
            rowset {
                id
                title
                price
                currency
                orderVolumeMin
                orderVolumeMax
                targetingsFixed {
                    viewTypes
                }
                targetingsCustom {
                    behaviors
                }
                dateStart
                dateEnd
            }
        }
    }
`;

export const pricePackagesForGroupQuery = gql`
    query PricePackagesForGroupQuery($input: GdGetPricePackagesInput!) {
        reqId: getReqId
        getPricePackages(input: $input) {
            rowset {
                id
                title
                targetingsFixed {
                    geo
                }
                targetingsCustom {
                    geo
                }
                lastUpdateTime
            }
        }
    }
`;
